import { ValidationErrors, AbstractControl } from '@angular/forms';

export const atleastOne = (control: AbstractControl): ValidationErrors | null => {
  // parse control value to Date
  const hasTrue = Object.values(control.value || {}).find((i) => i === true);
  // check if control value is superior to date given in parameter
  if (hasTrue) {
    return null;
  } else {
    return { required: true };
  }
};
